import * as angular from 'angular';
import 'angular-modal-service';
import 'angular-ui-router';
import permissions from 'application/detail/permissions.json';
import TeamView from './TeamView.html';
import { TeamController } from './TeamController';
import EditUserView from './editUser/editUserView.html';
import EditUserController from './editUser/editUserController';
import { TeamSegmentService } from './TeamSegmentService';
import { PaginationService } from 'modules/shared/Pagination/PaginationService';
export const teamStateName = 'auth.application.detail.team';
export const teamDetailStateName = 'auth.application.detail.team.edit';
//
export default angular
    .module('application.users', ['ui.router', 'angularModalService', 'shared'])
    .controller('UsersController', TeamController)
    .service('TeamSegmentService', TeamSegmentService)
    .service('PaginationService', PaginationService)
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider.state(teamStateName, {
            url: '/team',
            views: {
                'content@auth.application.detail': {
                    template: TeamView,
                    controller: TeamController,
                    controllerAs: '$ctrl',
                },
            },
            data: {
                permissionClaim: permissions.team.claim,
            },
            params: { area: 'team' },
        })
            .state(teamDetailStateName, {
            url: '/team/edit',
            views: {
                'content@auth.application.detail': {
                    template: EditUserView,
                    controller: EditUserController,
                    controllerAs: '$ctrl',
                },
            },
            params: { userData: undefined, newUser: undefined },
        });
    }]).name;
